import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

function PenalizadoEnPlaya (props) {
  const { numero } = props

  return (
    <>
      {numero &&
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            float: 'left'
          }}
        >
          <Tooltip title={'Ingresó en la playa'}>
            <IconButton>
              <InfoIcon fontSize='default' color='inherit' />
            </IconButton>
          </Tooltip>
          {numero
            ? <TableValueAction
              value={numero}
              title=' '
              content={<InfoCpa cpa={numero} />} />
            : null
          }
        </div>
      }
    </>
  )
}

export default PenalizadoEnPlaya
